import React, { Component } from "react";
import PropTypes from "prop-types";
import getConfig from "next/config";
import _get from "lodash/get";

import ContentEditorProductDescription from "@components/ProductPage/ProductDescription/ContentEditorProductDescription";
import EStoreMediaProductDescription from "@components/ProductPage/ProductDescription/EStoreMediaProductDescription";
import FlixMediaProductDescription from "@components/ProductPage/ProductDescription/FlixMediaProductDescription";
import StaticHTMLProductDescription from "@components/ProductPage/ProductDescription/StaticHTMLProductDescription";
import LoadBeeProductDescription from "@components/ProductPage/ProductDescription/LoadBeeProductDescription";
import _1WorldSyncProductDescription from "@components/ProductPage/ProductDescription/_1WorldSyncProductDescription";

const contentProviderComponentMapping = {
  loadBee: LoadBeeProductDescription,
  eStoreMedia: EStoreMediaProductDescription,
  flixMedia: FlixMediaProductDescription,
  contentEditor: ContentEditorProductDescription,
  staticHTML: StaticHTMLProductDescription,
  "1WorldSync": _1WorldSyncProductDescription,
};

const {
  publicRuntimeConfig: {
    contentProviders,
    settings: { productDescriptionFallbackMinLengthCheck },
  },
} = getConfig();

class ProductDescription extends Component {
  shouldComponentUpdate() {
    // TODO: Test if this is necessary
    return false;
  }

  getBrandContentProviderName = () => {
    const { brand } = this.props;

    if (brand) {
      const brandProviderName = _get(
        contentProviders,
        `brandContentProvider.${brand.toUpperCase()}`,
        ""
      );

      if (
        brandProviderName &&
        _get(
          contentProviders,
          `providers.${brandProviderName}.isEnabled`,
          false
        )
      ) {
        return brandProviderName;
      }
    }

    return "";
  };

  getContentProviderName = () => {
    const {
      useExternalContentProvider,
      contentEditorBlock,
      staticHTML,
      ean,
      brand,
    } = this.props;

    let hasContentEditorContent = false;

    if (contentEditorBlock && contentEditorBlock.length > 0) {
      try {
        hasContentEditorContent = JSON.parse(contentEditorBlock);
      } catch (error) {
        console.log(error);
      }
    }

    if (
      !useExternalContentProvider &&
      (staticHTML.length > productDescriptionFallbackMinLengthCheck ||
        (contentEditorBlock &&
          contentEditorBlock.length > productDescriptionFallbackMinLengthCheck))
    ) {
      if (staticHTML.includes("data-flix") && ean && brand) {
        return "flixMedia";
      } else {
        return hasContentEditorContent ? "contentEditor" : "staticHTML";
      }
    }

    return (
      this.getBrandContentProviderName() ||
      (hasContentEditorContent
        ? "contentEditor"
        : staticHTML.includes("data-flix") && ean && brand
        ? "flixMedia"
        : "staticHTML")
    );
  };

  render() {
    const {
      staticHTML,
      contentEditorBlock,
      ean,
      cmsBlocks,
      brand,
      productNumber,
    } = this.props;

    const contentProviderName = this.getContentProviderName();

    // console.warn("Product description content provider:", contentProviderName);

    const ContentProviderComponent =
      contentProviderComponentMapping[contentProviderName];

    return (
      <div className="Tabs-content p-0">
        <div className="Description">
          <div className="Cms">
            <div className="Cms-container relative">
              <div
                className={`mb-3 lg:mb-5 ${
                  contentProviderName === "staticHTML" ? "Cms-inner" : ""
                }`}
              >
                <ContentProviderComponent
                  contentEditorBlock={contentEditorBlock}
                  staticHTML={staticHTML}
                  ean={ean}
                  brand={brand}
                  productNumber={productNumber}
                />

                {_get(
                  cmsBlocks,
                  "altex_label/rule_action_type_cmsBlockBottom.content",
                  ""
                ) && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        cmsBlocks["altex_label/rule_action_type_cmsBlockBottom"]
                          .content,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProductDescription.defaultProps = {
  useExternalContentProvider: false,
  staticHTML: "",
  contentEditorBlock: "",
  cmsBlocks: null,
  ean: "",
  brand: "",
};

ProductDescription.propTypes = {
  staticHTML: PropTypes.string.isRequired,
  contentEditorBlock: PropTypes.string,
  cmsBlocks: PropTypes.object,
  ean: PropTypes.string,
  brand: PropTypes.string,
};

export default ProductDescription;
